import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { DatosDocumentacion } from "../../documentacion/edit/datosdocumentacion";
import { DatosGuia, ResumenGuia } from "./datosguia";
import { Paquetes, Sobres } from "./listas/index";
import { EnSucursalEdit } from "./ensucursal/modal";
import { StatusGuiaViewDTOList } from "./listas/status/list";
import { StatusRastreoDTOList } from "./../../../../rastreo/listastatus";

import { marcarGuiaRecolectada } from "./rad";
import { ResumenGuiaView } from "app/features/componentes/guia/resumenguia";
type Entity = models.GuiaDTO;
export interface Props {
    value: Entity;
    permisos: models.Rol;
    session: models.Session;
}

const MarcarRecolectada = kea.defaultProps(kea.Button, { children: "Recolectar a domicilio", style: "success", iconClass: fa("truck") });

/**
* Componente para editar un Entity
*/
export class GuiaFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => ({ value: this.props.value, readonly: true }), this.errors);
    modalManager = kea.createModalManager();

    puedeAsignarASucursal = (x: Props) => x.permisos.Guia.VerBotonAsignarASucursal;
    puedeVerDatosCliente = (x: Props) => x.permisos.Rastreo.VerBotonInformacionCliente;
    puedeVerBotonMarcarRAD = (x: Props) => x.permisos.RecoleccionDomicilio.VerBoton;

    private session = (props: Props) => props.session;
    private idCliente = createSelectorRx(this.session, session => (session.IdCliente || undefined));
    private esClienteUsuario = createSelectorRx(this.idCliente, idCliente => idCliente ? true : false);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    asignarASucursal = async () => {
        const result = await this.modalManager.showModal(EnSucursalEdit, undefined, { IdSucursal: undefined as any });
        if (result.result) {
            await resources.Logistica.GuiaEnSucursal(this.props.value.Folio, result.value.IdSucursal);
            await kea.message("Guia asignada a sucursal", "", "success");
        }
    }

    cargarHistorial = async () => {
        var ccc = await resources.Guia.GetHistorialGuia(this.props.value.IdRegistro);
        this.props.value.StatusHistoricos = ccc
        this.forceUpdate()
    }


    render() {
        const { value } = this.props;
        const getField = this.getField;

        var puedeAsignar = this.puedeAsignarASucursal(this.props);
        var puedeVerDatosCliente = this.puedeVerDatosCliente(this.props);
        var esClienteUsuario = this.esClienteUsuario(this.props);
        var VerBotonRAD = this.puedeVerBotonMarcarRAD(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const titulo =
            <span>
                {"Guía "}
                <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                    {value.Folio}
                </span>
            </span>
        return (
            <div>
                <kea.Title titulo={titulo} onRegresar={() => window.history.back()} >
                    {value.PuedeRecolectar && VerBotonRAD && <MarcarRecolectada onClick={() => marcarGuiaRecolectada(value.IdRegistro, this.modalManager.showModal)} />}
                    {
                        puedeAsignar &&
                        <kea.Button onClick={this.asignarASucursal}>
                            Asignar a sucursal
                        </kea.Button>
                    }
                </kea.Title>

                <ResumenGuiaView value={this.props.value} puedeVerDatosEntregaCliente={puedeVerDatosCliente} />

                <hr />
                <kea.Tab items={[
                    {
                        title: "Resumen",
                        body:
                        <div>
                            <ResumenGuia value={value} />
                            {kea.autogrid(6, [
                                <Paquetes value={value.Paquetes} />,
                                <Sobres value={value.Sobres} />,
                            ])}
                        </div>
                    }, {
                        title: "Detalle",
                        body:
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>Documentación</h3>
                                    <DatosDocumentacion value={value.Documentacion} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <h3>Guía</h3>
                                    <DatosGuia value={value} />
                                </div>
                            </div>
                        </div>
                    }, {
                        title: "Status",
                        body: 
                        <div>
                            {
                            kea.autogrid(6,[
                                <kea.Button style="info" onClick={this.cargarHistorial}>
                                    Cargar Historial
                                </kea.Button>])
                            }
                            {
                                kea.autogrid(12,[
                                    esClienteUsuario ? <StatusRastreoDTOList value={value.StatusHistoricos} /> : <StatusGuiaViewDTOList value={value.StatusHistoricos} />
                                ])
                            }
                        </div>
                    }
                ]} />

                {this.modalManager.component}
            </div>);
    }
}

export const GuiaForm = componentToRx(GuiaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/edit/form.tsx